import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportsService } from 'src/app/reports/reports.service';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { InbuiltFiltersV2Component } from '../inbuilt-filters-v2/inbuilt-filters-v2.component';
import { InbuiltTableV2Component } from '../inbuilt-table-v2/inbuilt-table-v2.component';
import { InbuiltMatrixV2Component } from '../inbuilt-matrix-v2/inbuilt-matrix-v2.component';
import { InbuiltDrillDownMatrixComponent } from '../inbuilt-drill-down-matrix/inbuilt-drill-down-matrix.component';
import { ParentChildTableComponent } from '../parent-child-table/parent-child-table.component';
import { ColumnChartV2Component } from '../column-chart-v2/column-chart-v2.component';
import { InbuiltBarChartV2Component } from '../inbuilt-bar-chart-v2/inbuilt-bar-chart-v2.component';
import { InbuiltHeaderV2Component } from '../inbuilt-donut-v2/inbuilt-donut-v2.component';
import { InbuiltCardV2Component } from '../inbuilt-card-v2/inbuilt-card-v2.component';
import { InbuiltSpeedometerV2Component } from '../inbuilt-speedometer-v2/inbuilt-speedometer-v2.component';
import { InbuiltStatCardComponent } from '../inbuilt-stat-card/inbuilt-stat-card.component';
import { InbuiltStackChartComponent } from '../inbuilt-stack-chart/inbuilt-stack-chart.component';

/**
 * Generic "describe what you want in plain language" prompt panel.
 * Presentational only - reusable anywhere an ASK-style tab is needed (filters, visuals, etc.).
 */
@Component({
    selector: 'app-ask-panel',
    templateUrl: './ask-panel.component.html',
    styleUrls: ['./ask-panel.component.scss'],
    imports: [MatIcon, NgIf, InbuiltFiltersV2Component, InbuiltTableV2Component, InbuiltMatrixV2Component, InbuiltDrillDownMatrixComponent, ParentChildTableComponent, ColumnChartV2Component, InbuiltBarChartV2Component, InbuiltHeaderV2Component, InbuiltCardV2Component, InbuiltSpeedometerV2Component, InbuiltStatCardComponent, InbuiltStackChartComponent]
})
export class AskPanelComponent {
  elementType: string = '';
  el: any;
  constructor(private reportsService: ReportsService) { }
  @Input() icon = 'auto_awesome';
  @Input() title = 'What would you like to add?';
  @Input() description = 'Use plain language. You can review the result in Visual Editor.';
  @Input() placeholder = 'Describe what you need';
  @Input() helperText = '';
  @Input() maxLength = 500;
  @Input() disabled = false;
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  onEnter(text: string): void {
    this.value = text;
    this.valueChange.emit(this.value);
    console.log('Input changed:', this.value);
    let payload = {
      "reportId": "70",
      "message": this.value
    };
    // call http or any other service to handle the input change
    this.reportsService.generateAiReportJson(payload).subscribe(
      response => {
        console.log('HTTP response:', response);
        this.elementType = response?.elementType;
        this.el = {element_json:response?.elementJson};
      },
      error => {
        console.error('HTTP error:', error);
      }
    );
  }
}
